import React, { Component } from 'react';
import ReactTable from "react-table";
import {
    Card,
    CardBody,
    CardTitle,
    CardText,
    Button, Modal, ModalHeader, ModalBody, Form, FormGroup, Label, Input, Row, Col,
    TabContent,
    TabPane,
    Nav,
    NavItem,
    NavLink,
} from 'reactstrap';
import "react-table/react-table.css";
import * as data from "../tables/reactable-data";
import classnames from 'classnames';
import avatar from '../../assets/images/users/3.jpg'
import ApexPieA from '../../components/apexpie-a'
import { auth } from '../../Api';
import { baseURL, baseImgURL } from '../../Api/BaseApi';
import { AutoComplete, Input as AInput } from 'antd';
import { CirclesWithBar } from 'react-loader-spinner'
import { Pagination } from 'antd';
import { personName } from '../../utils/people'
import { formatPhone } from '../../utils/phone'
import { deleteSucceeded, deleteFailedMessage, DELETE_UNREACHABLE } from '../../utils/deleteReply'
import { formatDutyDateTime } from '../../utils/dutyTime'
import BackToGuard from '../../components/people/backToGuard'
import { isPrivateAccount } from '../../utils/accountType'
import { REPLACES_DUTIES_NOTE } from '../../utils/dutyForm'

var tzOffset = require("tz-offset")

// One of the guard's details in the General Information card: two fit side by side on a wide screen
const DETAIL = { flex: "0 1 400px" };

class ReSellers extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            checked: false,
            open: false,
            modal: false,
            alertModal: false,
            obj: {},
            jsonData: [],
            originData: [],
            guardData: [],
            pastDutyData: [],
            midConfirmed: 5,
            midMissed: 5,
            startConfirmed: 5,
            startMissed: 5,
            endConfirmed: 5,
            endMissed: 5,
            data: data.makeData(),
            activeTab: '1',
            options: {},
            series: [44, 55, 41, 17, 15],
            labels: ['A', 'B', 'C', 'D', 'E'],
            guard: null,
            location: null,
            avatarUrl: '',
            loadingData: true,
            currentPage: 1,
            perPage: 10,
            totalCount: 500,
            showTable: true
        };
        this.toggle2 = this.toggle2.bind(this);
        this.toggle = this.toggle.bind(this);
        this.alertToggle = this.alertToggle.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    componentDidMount() {
        const { guard } = this.props.match.params
        var reqguard = {}
        reqguard.id = guard
        reqguard.company_id = localStorage.getItem('companyId')
        auth.getGuard(reqguard)
            .then((res) => {
                if (res.data.code == 200) {
                    this.setState({
                        guardData: res.data.message.users
                    })
                }
            })
        var req = {}
        if (guard != "null") {
            req.guard_id = guard
        }

        auth.getDuty(req)
            .then((res) => {
                if (res.data.code == 200) {
                    this.setState({
                        jsonData: res.data.message.users,
                        originData: res.data.message.users,
                        midConfirmed: res.data.message.mid_confirmed,
                        midMissed: res.data.message.mid_missed,
                        startConfirmed: res.data.message.start_confirmed,
                        startMissed: res.data.message.start_missed,
                        endConfirmed: res.data.message.end_confirmed,
                        endMissed: res.data.message.end_missed,
                        loadingData: false
                    })
                }
            })
        this.setState({
            guard: guard,
            alertModal: false,
        })
    }
    alertToggle() {
        this.setState({
            alertModal: !this.state.alertModal
        });
    }
    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }
    toggle2(tab) {
        if (this.state.activeTab !== tab) {
            if (tab == '2' && this.state.pastDutyData.length == 0) {
                this.setState({
                    loadingData: true
                })
                var req = {}
                req.is_past = true
                req.guard_id = this.state.guard
                req.current_page = 1
                req.per_page = 5
                auth.getDuty(req)
                    .then((res) => {
                        if (res.data.code == 200) {
                            this.setState({
                                pastDutyData: res.data.message.users,
                                loadingData: false,
                                totalCount: res.data.message.totalCount
                            })
                        }
                    })
            } else {
                this.setState({
                    loadingData: false
                })
            }
            this.setState({
                'activeTab': tab
            });
        }
    }

    changePagination(page, pageSize) {
        this.getPastDutyOnePage(page, pageSize)
    }

    changePageSize(current, size) {
        this.setState({
            perPage: size,
            showTable: false
        })
        if (current == 0) {
            this.getPastDutyOnePage(1, size)
            this.setState({ currentPage: 1 })
        } else {
            this.getPastDutyOnePage(current, size)
        }
        setTimeout(() => this.setState({ showTable: true }), 0)
    }

    getPastDutyOnePage(current, size) {
        this.setState({
            loadingData: true
        })
        var req = {}
        req.is_past = true
        req.guard_id = this.state.guard
        req.current_page = current
        req.per_page = size
        auth.getDuty(req)
            .then((res) => {
                if (res.data.code == 200) {
                    this.setState({
                        pastDutyData: res.data.message.users,
                        loadingData: false,
                        currentPage: current,
                    })
                }
            })
    }

    handleSubmit = (event) => {
        event.preventDefault();
        let id = event.target.id.value;
        let name = event.target.name.value;
        let designation = event.target.designation.value;
        let location = event.target.location.value;
        let age = event.target.age.value;
        let newObj = JSON.parse(JSON.stringify(this.state.jsonData));
        newObj[id] = [name, designation, location, age];
        this.setState({
            jsonData: newObj,
            modal: !this.state.modal
        })
    }

    displayDate(value) {
        var endtime = new Date(value)
        return endtime.getFullYear() + '-' + (endtime.getMonth() + 1) + '-' + endtime.getDate()
            + ' ' + (endtime.getHours() < 10 ? "0" + endtime.getHours() : endtime.getHours())
            + ":" + (endtime.getMinutes() < 10 ? "0" + endtime.getMinutes() : endtime.getMinutes()) + ":" + "00";
    }

    // Reloads the list only after the server has deleted it; a refusal is shown
    deleteRow() {
        const { obj } = this.state
        this.setState({ alertModal: false })
        auth.deleteDuty(obj)
            .then((res) => {
                if (deleteSucceeded(res)) {
                    this.componentDidMount()
                } else {
                    window.alert(deleteFailedMessage(res, 'The duty could not be deleted.'))
                }
            })
            .catch(() => window.alert(DELETE_UNREACHABLE))
    }

    handleSearch = (value) => {
        var searchData = [];
        this.state.originData.map((prop, key) => {
            if (prop.firstname.toLowerCase().includes(value.toLowerCase())
                || prop.secondname.toLowerCase().includes(value.toLowerCase())) {
                searchData.push(prop)
            }
        })
        this.setState({ jsonData: searchData })
    };


    render() {
        const { obj, guardData,totalCount, currentPage, perPage, showTable
        } = this.state;
        const data2 = this.state.jsonData.map((prop, key) => {
            return {
                id: key,
                name: (
                    <a onClick={() => this.props.history.push('/duty-detail/' + prop.id)} style={{ cursor: "pointer" }}>{prop.name}</a>
                ),
                client_name: prop.client_name,
                location_name: prop.location_name,
                supervisor_name: prop.supervisor_name,
                guard_name: prop.guard_name,
                starttime: <div title={prop.timezone}>{formatDutyDateTime(prop.starttime, prop.timezone)}</div>,
                duration: prop.duration,

                nomissedalert: prop.nomissedalert,
                statestart: prop.statestart,
                stateend: prop.stateend,
                edit: (
                    <div className="justify-content-center">
                        <Button className="btn-table-remove" onClick={() => {
                            this.setState({
                                alertModal: !this.state.alertModal,
                                obj: prop,
                            });
                        }}><i className="fas fa-trash-alt" style={{ color: "white" }} /></Button>
                    </div>
                ),
                linkPage: (
                    <div className="panel panel-default">
                        <div className="panel-heading">
                            <h6 className="panel-title">
                                <a onClick={function () {
                                    this.setState({ open: !this.state.open })
                                }.bind(this)} ><i className="fas fa-plus"></i>View</a>
                            </h6>
                        </div>
                        <div className={this.state.open ? "panel-collapse" : "panel-collapse panel-close"}>
                            <ul className="list-group">
                                <li className="list-group-item"><i className="mdi mdi-view-dashboard mr-10"></i>Dashboard</li>
                                <li className="list-group-item"><i className="ti-map-alt mr-10"></i>Districts</li>
                                <li className="list-group-item"><i className="mr-2 mdi mdi-account-settings mr-10"></i>Districts Managers</li>
                                <li className="list-group-item"><i className="icon-shield mr-10"></i>Guards</li>
                                <li className="list-group-item"><i className="mr-2 mdi mdi-account-alert mr-10"></i>Supervisors</li>
                                <li className="list-group-item"><i className="mr-2 mdi mdi-account-multiple-outline mr-10"></i>Clients</li>
                                <li className="list-group-item"><i className="icon-bell mr-10"></i>Alerts Template</li>
                                <li className="list-group-item"><i className="ti-align-left mr-10"></i>Duties</li>
                                <li className="list-group-item"><i className="icon-chart mr-10"></i>Billing</li>
                            </ul>
                        </div>
                    </div>
                )
            };
        });
        const data3 = this.state.pastDutyData.map((prop, key) => {
            return {
                id: key,
                name: (
                    <a onClick={() => this.props.history.push('/duty-detail/' + prop.id)} style={{ cursor: "pointer" }}>{prop.name}</a>
                ),
                client_name: prop.client_name,
                location_name: prop.location_name,
                supervisor_name: prop.supervisor_name,
                guard_name: prop.guard_name,
                starttime: <div title={prop.timezone}>{formatDutyDateTime(prop.starttime, prop.timezone)}</div>,
                duration: prop.duration,
                trackRate: (prop.trackingCount).toString() + '/' + (Math.ceil(prop.duration / 2)).toString(),
                online: prop.online,
                offline: prop.offline,
                nomissedalert: prop.nomissedalert,
                statestart: prop.statestart,
                stateend: prop.stateend,
                edit: (
                    <div className="justify-content-center">
                        <Button className="btn-table-remove ml-3" onClick={() => {
                            this.setState({
                                alertModal: !this.state.alertModal,
                                obj: prop,
                            });
                        }}><i className="fas fa-trash-alt" style={{ color: "white" }} /></Button>
                    </div>
                )
            };
        });

        return <div>
            {/*--------------------------------------------------------------------------------*/}
            {/* Start Action table*/}
            {/*--------------------------------------------------------------------------------*/}
            <Modal isOpen={this.state.modal} toggle={this.toggle}>
                <ModalHeader toggle={this.toggle}><h3>Duty Edit</h3></ModalHeader>
                {
                    obj == {} ? <div></div> : <ModalBody>
                        <Form onSubmit={this.handleSubmit}>
                            {/* <Input type="hidden" name="id" id="id" defaultValue={obj.id} /> */}
                            <FormGroup>
                                <Label for="name">Duty Name</Label>
                                <Input type="text" name="name" id="name" defaultValue={obj.name} />
                            </FormGroup>
                            <FormGroup>
                                <Label for="name">StartTime</Label>
                                <Input type="text" name="name" id="name" defaultValue={obj.name} />
                            </FormGroup>
                            <FormGroup>
                                <Label for="name">Duration</Label>
                                <Input type="text" name="name" id="name" defaultValue={obj.name} />
                            </FormGroup>
                            <FormGroup style={{ textAlign: "center" }}>
                                <Button color="primary" className="modal-btn mr-1" type="submit">Save</Button>
                                <Button color="secondary" className="modal-btn ml-1" onClick={this.toggle}>Cancel</Button>
                            </FormGroup>
                        </Form>
                    </ModalBody>}
            </Modal>
            <Modal isOpen={this.state.alertModal} toggle={this.alertToggle}>
                {/* <ModalHeader toggle={this.alertToggle}>Alert Modal</ModalHeader> */}
                <ModalBody className="alert-body">
                    <i className="mdi mdi-alert-circle ft-60"></i>
                    <h2>Delete this duty?</h2>
                    <div>This deletes the duty for good, with its alerts, rest breaks and tracking.</div>
                    <div className="height-10"></div>
                    <FormGroup>
                        <Button color="secondary" className="modal-btn ml-1" onClick={this.alertToggle}>Cancel</Button>
                        <span>&nbsp;&nbsp;</span>
                        <Button color="primary" className="modal-btn mr-1" onClick={() => this.deleteRow()}>Yes, Delete It!</Button>
                    </FormGroup>
                </ModalBody>
            </Modal>
            <div className="height-10"></div>
            {guardData.length > 0 ? <BackToGuard guardId={this.state.guard} name={personName(guardData[0], 'guard')} /> : null}
            <Card>
                <CardTitle className="mb-0 p-3 border-bottom bg-light">
                    <Row className="toolbar up-card-title">
                        {/* The guard's own name */}
                        <div className="b-title"><i className="mdi mdi-buffer mr-10"></i>&nbsp;{guardData.length != 0 ? (personName(guardData[0], 'guard') || 'Guard') + ': duties' : 'Duties'}</div>
                    </Row>
                    <Row className="d-flex mr-0 ml-0" style={{ alignItems: "center" }}>
                        {guardData.length != 0 ? <div className="toolbar up-card-box d-flex flex-wrap w-100">
                            <div className="pt-2 pb-2 mr-4">
                                <img src={guardData[0].avatar != null ? guardData[0].avatar == "/storage/avatar.jpg" ? avatar 
                                : baseImgURL + guardData[0].avatar : avatar} className="img-company"></img></div>
                            <div className="d-flex flex-wrap" style={{ flex: "1 1 300px", maxWidth: 840 }}>
                                <Row className="company-text-area" style={DETAIL}>
                                    <div className="company-text-key">Name</div>
                                    <div className="company-text-value">{personName(guardData[0], 'guard')}</div>
                                </Row>
                                <Row className="company-text-area" style={DETAIL}>
                                    <div className="company-text-key">Phone</div>
                                    <div className="company-text-value">{formatPhone(guardData[0].phone)}</div>
                                </Row>
                                {/* A Private account has only itself */}
                                {!isPrivateAccount() && <Row className="company-text-area" style={DETAIL}>
                                    <div className="company-text-key">Active Company</div>
                                    <div className="company-text-value">{guardData[0].company_name}</div>
                                </Row>}
                                <Row className="company-text-area" style={DETAIL}>
                                    <div className="company-text-key">CID</div>
                                    <div className="company-text-value">{guardData[0].CID}</div>
                                </Row>
                            </div>
                        </div> : <div className="toolbar up-card-box d-flex flex-wrap w-100">
                            <div className="pt-2 pb-2 mr-4"><img src={avatar} className="img-company"></img></div>
                            <div className="d-flex flex-wrap" style={{ flex: "1 1 300px", maxWidth: 840 }}>
                                <Row className="company-text-area" style={DETAIL}>
                                    <div className="company-text-key">Name</div>
                                    <div className="company-text-value">Trial Trial</div>
                                </Row>
                                <Row className="company-text-area" style={DETAIL}>
                                    <div className="company-text-key">Phone</div>
                                    <div className="company-text-value">+1234567890</div>
                                </Row>
                                {!isPrivateAccount() && <Row className="company-text-area" style={DETAIL}>
                                    <div className="company-text-key">Active Company</div>
                                    <div className="company-text-value">True</div>
                                </Row>}
                                <Row className="company-text-area" style={DETAIL}>
                                    <div className="company-text-key">CID</div>
                                    <div className="company-text-value">CID000</div>
                                </Row>
                            </div>
                        </div>}
                    </Row>
                </CardTitle>
                <CardBody>
                    <div className="add-button add-button-top">
                        <a onClick={() => this.props.history.push('/duty-edit/g' + this.state.guard)}><Button className="btn" color="primary" size="lg" active>
                            <i className="fas fa-user-plus"></i> Add New Duty
                        </Button></a>
                        <p className="replaces-duties-note text-muted mb-0 mt-1">{REPLACES_DUTIES_NOTE}</p>
                    </div>
                    <Row className="table-header">
                        <div className="table-title center-center">
                            <i className="ti-align-left"></i>
                            <span> Guard Duties</span>{this.state.loadingData && <span className="table-title center-center" style={{ color: 'green' }}>&nbsp;Loading
                                <CirclesWithBar
                                    height="25"
                                    width="25"
                                    radius="3"
                                    color="green"
                                    ariaLabel="loading"
                                    wrapperStyle
                                    wrapperClass
                                /></span>}</div>

                        <div style={{ width: 300 }} className="auto-complete">
                            <AutoComplete
                                dropdownMatchSelectWidth={252}
                                style={{
                                    width: 300,
                                }}
                                options={[]}
                                onSearch={this.handleSearch}
                            >
                                <AInput size="large" placeholder="Search" />
                            </AutoComplete>
                        </div>
                    </Row>
                    <div className="nav-header-cus">
                        <Nav tabs>
                            <NavItem>
                                <NavLink
                                    className={classnames({
                                        'active': this.state.activeTab === '1'
                                    })}
                                    onClick={() => { this.toggle2('1'); }}>
                                    Current/Future Duties

                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={classnames({
                                        'active': this.state.activeTab === '2'
                                    })}
                                    onClick={() => { this.toggle2('2'); }}>
                                    Past Duties
                                </NavLink>
                            </NavItem>
                        </Nav>
                    </div>

                    <TabContent activeTab={this.state.activeTab}>
                        <TabPane tabId="1">
                            <ReactTable className="tab-Table"
                                columns={[
                                    {
                                        Header: "No",
                                        id: "row",
                                        maxWidth: 50,
                                        filterable: false,
                                        Cell: (row) => {
                                            return <div>{row.index + 1}</div>;
                                        }
                                    },
                                    {
                                        Header: "Duty Alias",
                                        accessor: "name"
                                    },
                                    ...(isPrivateAccount() ? [] : [{ Header: "Client", accessor: "client_name" }]),
                                    {
                                        Header: "Location",
                                        accessor: "location_name"
                                    },
                                    {
                                        Header: "Guard",
                                        accessor: "guard_name"
                                    },
                                    ...(isPrivateAccount() ? [] : [{ Header: "Supervisor", accessor: "supervisor_name" }]),
                                    {
                                        Header: "Start (location time)",
                                        accessor: "starttime"
                                    },
                                    {
                                        Header: "Duration",
                                        accessor: "duration"
                                    },
                                    {
                                        Header: "Missed Alerts",
                                        accessor: "nomissedalert"
                                    },
                                    {
                                        Header: "Started In Location",
                                        accessor: "statestart"
                                    },
                                    {
                                        Header: "Ended in Location",
                                        accessor: "stateend"
                                    },
                                    {
                                        Header: "",
                                        accessor: "edit",
                                        id: "row",
                                        maxWidth: 70,
                                        filterable: false,

                                    },
                                ]}
                                defaultPageSize={10}
                                showPaginationBottom={false}
                                data={data2}
                            />
                        </TabPane>

                        <TabPane tabId="2">
                            {showTable && <ReactTable className="tab-Table"
                                columns={[
                                    {
                                        Header: "No",
                                        id: "row",
                                        maxWidth: 50,
                                        filterable: false,
                                        Cell: (row) => {
                                            return <div>{row.index + 1 + (currentPage - 1) * perPage}</div>;
                                        }
                                    },
                                    {
                                        Header: "Duty Alias",
                                        accessor: "name"
                                    },
                                    ...(isPrivateAccount() ? [] : [{ Header: "Client", accessor: "client_name" }]),
                                    {
                                        Header: "Location",
                                        accessor: "location_name"
                                    },
                                    {
                                        Header: "Guard",
                                        accessor: "guard_name"
                                    },
                                    ...(isPrivateAccount() ? [] : [{ Header: "Supervisor", accessor: "supervisor_name" }]),
                                    {
                                        Header: "Start (location time)",
                                        accessor: "starttime"
                                    },
                                    {
                                        Header: "Duration",
                                        accessor: "duration"
                                    },
                                    {
                                        Header: "Tracking Rate",
                                        accessor: "trackRate"
                                    },
                                    {
                                        Header: "Tracking Online",
                                        accessor: "online"
                                    },
                                    {
                                        Header: "Tracking Offline",
                                        accessor: "offline"
                                    },
                                    {
                                        Header: "Missed Alerts",
                                        accessor: "nomissedalert"
                                    },
                                    {
                                        Header: "Started In Location",
                                        accessor: "statestart"
                                    },
                                    {
                                        Header: "Ended in Location",
                                        accessor: "stateend"
                                    },
                                    {
                                        Header: "",
                                        accessor: "edit",
                                        id: "row",
                                        maxWidth: 100,
                                        filterable: false,
                                    },
                                ]}
                                defaultPageSize={perPage}
                                showPaginationBottom={false}
                                data={data3}
                            // filterable
                            />}
                            <div className='center-center mt-2'>
                                <Pagination defaultCurrent={currentPage}
                                    defaultPageSize={perPage}
                                    total={totalCount}
                                    pageSizeOptions={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 15, 20, 30]}
                                    onChange={(page, pageSize) => this.changePagination(page, pageSize)}
                                    onShowSizeChange={(current, size) => this.changePageSize(current, size)}
                                />
                            </div>
                        </TabPane>
                    </TabContent>
                </CardBody>
            </Card>
            {/*--------------------------------------------------------------------------------*/}
            {/* End Action table*/}
            {/*--------------------------------------------------------------------------------*/}
        </div>
    }
}
export default ReSellers;
